import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <p>&copy; 2025 HYconnect. {t('description')}</p>
    </footer>
  );
};

export default Footer;